import React, { useMemo } from 'react';
import { Select } from 'antd';
import { StyledPagination } from './index.styled';

const ALL_PAGE_SIZES = [10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 7000, 10000];

type AppsPaginationProps = {
  className?: string;
  page: number;
  pageSize?: number;
  total?: number;
  onChange: (page: number, pageSize: number) => void;
  showSizeChanger?: boolean;
  pageSizeOptions?: number[];

  [x: string]: any;
};

const AppsPagination: React.FC<AppsPaginationProps> = ({
  total,
  page = 0,
  pageSize = 20,
  className = '',
  onChange,
  showSizeChanger = true,
  pageSizeOptions,
  ...rest
}) => {
  const { options, shouldShow } = useMemo(() => {
    const sizes = pageSizeOptions ?? ALL_PAGE_SIZES;
    const t = total || 0;
    const filtered = sizes.filter(
      (_size, i) => i === 0 || sizes[i - 1] < t,
    );
    return {
      options: filtered.map(String),
      shouldShow: filtered.length > 1,
    };
  }, [total, pageSizeOptions]);

  return (
    <StyledPagination
      {...rest}
      total={total || 0}
      pageSize={pageSize}
      className={className}
      current={(page || 0) + 1}
      onChange={onChange}
      showQuickJumper
      showSizeChanger={showSizeChanger && shouldShow}
      sizeChangerRender={({ size: _size, ...info }) => (
        <Select
          {...info}
          placement="topRight"
          getPopupContainer={() => document.body}
        />
      )}
      pageSizeOptions={options}
      showTotal={(total) => {
        const start = page * pageSize + 1;
        const end = Math.min((page + 1) * pageSize, total);
        return `Showing ${start} - ${end} of ${total}`;
      }}
    />
  );
};

export default AppsPagination;
